module.exports = __webpack_public_path__ + "static/media/validarPedido.6a078f3e.png";